import ScrollReveal from '@/components/common/ScrollReveal';
import GradientIcon from '@/components/common/GradientIcon';
import { benefits, promos } from '@/mocks/landing';
import SectionTitle from './SectionTitle';

export default function Benefits() {
  return (
    <section id="features" className="w-full bg-white pb-16 md:pb-24">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <SectionTitle sparkle title="Built for teams that run loyalty seriously" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {benefits.map((b, i) => (
            <ScrollReveal key={b.title} animation="fade-up" delay={i * 80}>
              <a href="#products" className="group block rounded-2xl bg-[#f5f6fa] border border-transparent hover:border-[#dfe3ff] hover:bg-white hover:shadow-[0_16px_40px_-24px_rgba(47,81,214,0.5)] transition-all overflow-hidden">
                <div className={`relative h-36 bg-gradient-to-br ${b.art} flex items-center justify-center`}>
                  <span className="absolute top-3 left-3 inline-flex items-center gap-1 rounded-md bg-white/80 px-2 py-0.5 text-[11px] text-[#646a73]">
                    <GradientIcon icon={b.icon} tone={b.tone} size="text-xs" /> {b.tag}
                  </span>
                  <div className="w-20 h-20 rounded-3xl bg-white/80 backdrop-blur shadow-[0_14px_30px_-12px_rgba(47,81,214,0.45)] flex items-center justify-center group-hover:scale-105 transition-transform">
                    <GradientIcon icon={b.icon} tone={b.tone} size="text-5xl" />
                  </div>
                </div>
                <div className="p-4 flex items-end gap-3">
                  <div className="flex-1">
                    <h3 className="font-bold text-[#1f2329]">{b.title}</h3>
                    <p className="mt-1 text-xs text-[#8f959e]">{b.text}</p>
                  </div>
                  <i className="ri-arrow-right-line text-[#2f51d6] group-hover:translate-x-1 transition-transform" />
                </div>
              </a>
            </ScrollReveal>
          ))}
        </div>

        <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
          {promos.map((p, i) => (
            <ScrollReveal key={p.title} animation="fade-up" delay={i * 80}>
              <a
                href="#contact"
                className="group flex items-center gap-4 rounded-2xl bg-gradient-to-r from-[#f5f6fa] to-[#eef1ff] p-5 hover:shadow-[0_16px_40px_-24px_rgba(47,81,214,0.5)] transition-all"
              >
                <div className="flex-1">
                  <h3 className="font-bold text-[#1f2329]">{p.title}</h3>
                  <p className="mt-1 text-xs text-[#8f959e]">{p.text}</p>
                </div>
                <div className="relative">
                  <span className="absolute -top-2 -right-2 text-[9px] font-bold rounded-full bg-gradient-to-r from-[#ff4d8d] to-[#ff8a5c] text-white px-1.5 py-0.5">
                    {p.badge}
                  </span>
                  <span className="w-14 h-14 rounded-2xl bg-white shadow-sm flex items-center justify-center group-hover:rotate-6 transition-transform">
                    <GradientIcon icon={p.icon} tone={p.tone} size="text-3xl" />
                  </span>
                </div>
              </a>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
